module.exports = __webpack_public_path__ + "static/media/galeryDoors3.bd7d4c96.jpg";